/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnCreateChallenge
 */
export interface WebAuthnCreateChallenge {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnCreateChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnCreateChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof WebAuthnCreateChallenge
     */
    authentication_method: FactorMethod;
    /**
     * The "Options for Credential Creation" as described by the WebAuthn spec at https://www.w3.org/TR/webauthn/#dictionary-makecredentialoptions
     * @type {object}
     * @memberof WebAuthnCreateChallenge
     */
    options?: object;
}



/**
 * Check if a given object implements the WebAuthnCreateChallenge interface.
 */
export function instanceOfWebAuthnCreateChallenge(value: object): value is WebAuthnCreateChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function WebAuthnCreateChallengeFromJSON(json: any): WebAuthnCreateChallenge {
    return WebAuthnCreateChallengeFromJSONTyped(json, false);
}

export function WebAuthnCreateChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function WebAuthnCreateChallengeToJSON(json: any): WebAuthnCreateChallenge {
    return WebAuthnCreateChallengeToJSONTyped(json, false);
}

export function WebAuthnCreateChallengeToJSONTyped(value?: WebAuthnCreateChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': value['options'],
    };
}

